export default __webpack_public_path__ + "static/media/Imagen_business.ef9bdd93.png";